// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"530":"8ba6b0208666434a244e","540":"0525dac9dcedc4dd5f96","676":"3647659718b17a21429e","780":"8f0eea24ba326f6a1b0e"}[chunkId] + ".chunk.js";
};